<div class="page-header">
    <div class="col-12">
        <h1>Revenue/Cost Projections <small>View revenue and cost projections summarized by month</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1">
            <a ngbNavLink>Revenue Earned</a>
        </li>
        <li [ngbNavItem]="3">
            <a ngbNavLink>Revenue Billed</a>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>GP/GM</a>
        </li>
        <li [ngbNavItem]="11">
            <a ngbNavLink>Job Type Summary</a>
        </li>
        <li [ngbNavItem]="7">
            <a ngbNavLink>Costs/Hours</a>
        </li>
        <li [ngbNavItem]="8">
            <a ngbNavLink>Labor Phase Costs/Hours</a>
        </li>
        <li [ngbNavItem]="9">
            <a ngbNavLink>Validation</a>
        </li>
        <li [ngbNavItem]="10">
            <a ngbNavLink>Cost Changes</a>
        </li>
    </ul>

    <!-- Menu -->
    <wj-menu
        #ctxMenu
        style="display: none"
        [selectedValuePath]="'cmd'"
        [displayMemberPath]="'header'"
        (itemClicked)="menuItemClicked(ctxMenu)"
        [itemsSource]="menuItems"
        [dropDownCssClass]="'ctx-menu'"
    >
        <wj-menu-item cmd="cmdNew"> <span class="glyphicon glyphicon-asterisk"></span>&nbsp;&nbsp;New </wj-menu-item>
    </wj-menu>

    <div style="margin-top: 20px" [hidden]="active > 3">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                    <grid-export [grid]="mainGrid" [name]="'Actual/Projected Earned Revenue'" [hidden]="active !== 1"></grid-export>
                    <grid-export [grid]="mainGrid" [name]="'Actual/Projected Billed Amount'" [hidden]="active !== 3"></grid-export>
                    <grid-export [grid]="mainGrid" [name]="'GP/GM'" [hidden]="active !== 2"></grid-export>

                    <div class="input-header-group">
                        <span class="input-header">Years</span>
                        <wj-multi-select
                            #multiSelect
                            [itemsSource]="availableYears"
                            [checkedMemberPath]="'checked'"
                            [placeholder]="'Choose Years'"
                            style="width: 150px"
                            [selectedValuePath]="'value'"
                            [displayMemberPath]="'display'"
                            (checkedItemsChanged)="yearsChanged()"
                        ></wj-multi-select>
                    </div>

                    <div class="input-header-group">
                        <span class="input-header">Job Status</span>
                        <wj-multi-select
                            name="jobActvityType"
                            (checkedItemsChanged)="jobStatusChanged()"
                            [itemsSource]="activeMap"
                            [displayMemberPath]="'display'"
                            [checkedMemberPath]="'$checked'"
                            [showSelectAllCheckbox]="true"
                        ></wj-multi-select>
                    </div>

                    <div class="input-header-group">
                        <span class="input-header">Group By</span>
                        <wj-combo-box
                            [(ngModel)]="selectedGrouping"
                            name="selectedGrouping"
                            (ngModelChange)="prepareData()"
                            [itemsSource]="groupingOptions"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>

                    <div class="input-header-group">
                        <span class="input-header">Projection Start Month</span>
                        <wj-input-date
                            [(ngModel)]="projectionStartMonth"
                            name="projectionStartMonth"
                            (ngModelChange)="projectionStartMonthChanged()"
                            [selectionMode]="'Month'"
                            [format]="'MMM yyyy'"
                        ></wj-input-date>
                    </div>
                    @if (projectionStartMonthWarning) {
                        <span style="line-height: 30px; color: darkorange; margin-left: 10px;">
                            {{ projectionStartMonthWarning }}
                        </span>
                    }
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="mainGrid"
                    #mainGrid
                    appAutoSize
                    [padding]="73"
                    (initialized)="grid.initialize(mainGrid)"
                    [itemFormatter]="mainGridItemFormatter"
                    [itemsSource]="grid.view"
                    [keyActionTab]="'MoveAcross'"
                    [frozenColumns]="frozenColumns"
                    (beginningEdit)="cellBeginningEdit(mainGrid, $event)"
                    (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Job / Grouping'"
                        [binding]="'job'"
                        [width]="350"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Job Contract'"
                        [binding]="'jobContract'"
                        [width]="120"
                        [format]="'C0'"
                        [align]="'right'"
                        [isReadOnly]="true"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Vista Accrued + Projections (All Years)'"
                        [binding]="'billedPlusProjection'"
                        [width]="140"
                        [format]="'C0'"
                        [align]="'right'"
                        [isReadOnly]="true"
                        [visible]="active === 3"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Remaining To Project (All Years)'"
                        [binding]="'remainingToProject'"
                        [width]="120"
                        [format]="'C2'"
                        [align]="'right'"
                        [isReadOnly]="true"
                        [visible]="active === 3"
                    ></wj-flex-grid-column>
                    <!--<wj-flex-grid-column [header]="'GM %'" [binding]="'gm'" [width]="175" [isReadOnly]="true"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'WIP Backlog'" [binding]="'wip'" [width]="150" [isReadOnly]="true"></wj-flex-grid-column>-->
                    @for (month of monthCols; track month) {
                        <wj-flex-grid-column
                            [binding]="'detailsByMonth.' + month + '.revenue'"
                            [format]="'C2'"
                            [align]="'right'"
                            [header]="month"
                            [aggregate]="'Sum'"
                            [width]="120"
                            [isReadOnly]="false"
                        >
                        </wj-flex-grid-column>
                    }
                </wj-flex-grid>
                <grid-selection-calculation [grid]="mainGrid"></grid-selection-calculation>
            </div>
        </div>
    </div>

    <div style="margin-top: 10px" [hidden]="active !== 4">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <grid-export [grid]="gridBonus" [name]="'Job Scheduling'"></grid-export>
                    <wj-combo-box
                        [(ngModel)]="selectedYear"
                        name="selectedYear"
                        (ngModelChange)="refreshBonus()"
                        [itemsSource]="yearMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="gridBonus"
                    #gridBonus
                    appAutoSize
                    [padding]="73"
                    (initialized)="bonusGrid.initialize(gridBonus)"
                    [itemFormatter]="bonusGridItemFormatter"
                    [itemsSource]="bonusGrid.view"
                    [keyActionTab]="'CycleEditable'"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="' '" [binding]="'metric'" [width]="'1.5*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'90% PLAN'" [binding]="'plan90'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'95% PLAN'" [binding]="'plan95'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'PLAN'" [binding]="'plan'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 2'" [binding]="'level2'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 3'" [binding]="'level3'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 4'" [binding]="'level4'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 5'" [binding]="'level5'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 6'" [binding]="'level6'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 7'" [binding]="'level7'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'LEVEL 8'" [binding]="'level8'" [format]="'N0'" [width]="'*'"></wj-flex-grid-column>
                </wj-flex-grid>
                <grid-selection-calculation [grid]="gridBonus"></grid-selection-calculation>
            </div>
        </div>
    </div>
    <div style="margin-top: 10px" [hidden]="active !== 5">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="bonusInputGrid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="bonusInputGrid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <grid-export [grid]="gridBonusInput" [name]="'Job Scheduling'"></grid-export>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    id="gridBonusInput"
                    #gridBonusInput
                    appAutoSize
                    [padding]="73"
                    (initialized)="bonusInputGrid.initialize(gridBonusInput)"
                    [itemsSource]="bonusInputGrid.view"
                    [keyActionTab]="'CycleEditable'"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column [header]="'Year'" [binding]="'year'" [width]="'*'" [format]="'d'"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Plan Percent'"
                        [binding]="'planPercent'"
                        [format]="'P2'"
                        [width]="'*'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Bonus Pool Percent'"
                        [binding]="'bonusPoolPercent'"
                        [format]="'P2'"
                        [width]="'*'"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Overhead'" [binding]="'overhead'" [format]="'C0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Plan'" [binding]="'plan'" [format]="'C0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Extra'" [binding]="'extra'" [format]="'C0'" [width]="'*'"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Other Income'"
                        [binding]="'otherIncome'"
                        [format]="'C0'"
                        [width]="'*'"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
                <grid-selection-calculation [grid]="gridBonusInput"></grid-selection-calculation>
            </div>
        </div>
    </div>
    <div style="margin-top: 10px" [hidden]="active !== 6">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <wj-input-date
                        [(ngModel)]="gaugeDate"
                        name="gaugeDate"
                        (ngModelChange)="refresh()"
                        [selectionMode]="'Month'"
                        [format]="'M/d/yyyy'"
                    ></wj-input-date>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <h2 style="text-align: center">Actual Gross Margin {{ currentYear }}</h2>
                <wj-radial-gauge
                    #gauge
                    [min]="0"
                    [max]="120"
                    [isReadOnly]="true"
                    [value]="progress"
                    [showText]="'None'"
                    [startAngle]="-45"
                    [sweepAngle]="270"
                    [tickSpacing]="20"
                    [needleShape]="'Pointer'"
                    [needleLength]="'Outer'"
                    [thickness]="0.3"
                    [showTicks]="true"
                    [showTickText]="true"
                    [showRanges]="true"
                >
                    <wj-range [min]="ranges[0]" [max]="ranges[1]" [color]="'#92ff92'"></wj-range>
                    <wj-range [min]="ranges[1]" [max]="ranges[2]" [color]="'#6fe16f'"></wj-range>
                    <wj-range [min]="ranges[2]" [name]="'blaj'" [max]="ranges[3]" [color]="'#4fc14f'"></wj-range>
                    <wj-range [min]="ranges[3]" [max]="ranges[4]" [color]="'#319f31'"></wj-range>
                    <wj-range [min]="ranges[4]" [max]="ranges[5]" [color]="'#1d871d'"></wj-range>
                    <wj-range [min]="ranges[5]" [max]="ranges[6]" [color]="'#0b680b'"></wj-range>
                    <wj-range [min]="ranges[6]" [max]="ranges[7]" [color]="'#004e00'"></wj-range>
                    <wj-range [min]="ranges[7]" [max]="120" [color]="'#013801'"></wj-range>
                </wj-radial-gauge>
                <h4 style="text-align: center">{{ progress | number: '1.2-2' }}% of Level 1 (100%)</h4>
                <h4 style="text-align: center">Reach Level 8 at {{ ranges[7] | number: '1.2-2' }}%!</h4>
                <br />
                <h4 style="text-align: center">
                    Actual GM as of {{ gaugeDate | date: 'shortDate' }} {{ currentYearTotalActualProfit | currency }}
                </h4>
            </div>
            <div class="col-4">
                <h2 style="text-align: center">Actual + Projected Gross Margin {{ currentYear }}</h2>
                <wj-radial-gauge
                    [min]="0"
                    [max]="120"
                    [value]="progress2"
                    [showText]="'None'"
                    [startAngle]="-45"
                    [sweepAngle]="270"
                    [tickSpacing]="20"
                    [needleShape]="'Pointer'"
                    [needleLength]="'Outer'"
                    [thickness]="0.3"
                    [showTicks]="true"
                    [showTickText]="true"
                    [showRanges]="true"
                >
                    <wj-range [min]="ranges[0]" [max]="ranges[1]" [color]="'#92ff92'"></wj-range>
                    <wj-range [min]="ranges[1]" [max]="ranges[2]" [color]="'#6fe16f'"></wj-range>
                    <wj-range [min]="ranges[2]" [max]="ranges[3]" [color]="'#4fc14f'"></wj-range>
                    <wj-range [min]="ranges[3]" [max]="ranges[4]" [color]="'#319f31'"></wj-range>
                    <wj-range [min]="ranges[4]" [max]="ranges[5]" [color]="'#1d871d'"></wj-range>
                    <wj-range [min]="ranges[5]" [max]="ranges[6]" [color]="'#0b680b'"></wj-range>
                    <wj-range [min]="ranges[6]" [max]="ranges[7]" [color]="'#004e00'"></wj-range>
                    <wj-range [min]="ranges[7]" [max]="120" [color]="'#013801'"></wj-range>
                </wj-radial-gauge>
                <h4 style="text-align: center">{{ progress2 | number: '1.2-2' }}% of Level 1 (100%)</h4>
                <h4 style="text-align: center">Reach Level 8 at {{ ranges[7] | number: '1.2-2' }}%!</h4>
                <br />
                <h4 style="text-align: center">Projected GM {{ projectedProfit | currency }}</h4>
            </div>
            <div class="col-4">
                <h2 style="text-align: center">Projected Gross Margin {{ currentYear + 1 }}</h2>
                <wj-radial-gauge
                    [min]="0"
                    [max]="120"
                    [value]="nextYearProgress"
                    [showText]="'None'"
                    [startAngle]="-45"
                    [sweepAngle]="270"
                    [tickSpacing]="20"
                    [needleShape]="'Pointer'"
                    [needleLength]="'Outer'"
                    [thickness]="0.3"
                    [showTicks]="true"
                    [showTickText]="true"
                    [showRanges]="true"
                >
                    <wj-range [min]="ranges[0]" [max]="ranges[1]" [color]="'#92ff92'"></wj-range>
                    <wj-range [min]="ranges[1]" [max]="ranges[2]" [color]="'#6fe16f'"></wj-range>
                    <wj-range [min]="ranges[2]" [max]="ranges[3]" [color]="'#4fc14f'"></wj-range>
                    <wj-range [min]="ranges[3]" [max]="ranges[4]" [color]="'#319f31'"></wj-range>
                    <wj-range [min]="ranges[4]" [max]="ranges[5]" [color]="'#1d871d'"></wj-range>
                    <wj-range [min]="ranges[5]" [max]="ranges[6]" [color]="'#0b680b'"></wj-range>
                    <wj-range [min]="ranges[6]" [max]="ranges[7]" [color]="'#004e00'"></wj-range>
                    <wj-range [min]="ranges[7]" [max]="120" [color]="'#013801'"></wj-range>
                </wj-radial-gauge>
                <h4 style="text-align: center">{{ currentYear + 1 }} Projected GM {{ nextYearGP | currency }}</h4>
            </div>
        </div>
    </div>
    <div style="margin-top: 20px" [hidden]="active !== 7">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <div class="input-header-group">
                        <span class="input-header">Job Status</span>
                        <wj-multi-select
                            name="costJobStatus"
                            (checkedItemsChanged)="jobStatusChanged()"
                            [itemsSource]="activeMap"
                            [displayMemberPath]="'display'"
                            [checkedMemberPath]="'$checked'"
                            [showSelectAllCheckbox]="true"
                        ></wj-multi-select>
                    </div>
                    <div class="input-header-group">
                        <span class="input-header">Jobs</span>
                        <wj-multi-select
                            style="width: 350px"
                            [itemsSource]="activeJobsMap"
                            [placeholder]="'Choose Jobs'"
                            [selectedValuePath]="'value'"
                            [displayMemberPath]="'display'"
                            [checkedMemberPath]="'selected'"
                            [showSelectAllCheckbox]="true"
                            [showFilterInput]="true"
                            [maxHeaderItems]="1"
                            (checkedItemsChanged)="refreshCostData()"
                        ></wj-multi-select>
                    </div>
                    <div class="input-header-group">
                        <span class="input-header">Display</span>
                        <wj-combo-box
                            [(ngModel)]="costHourType"
                            name="costHourType"
                            style="width: 180px"
                            [itemsSource]="costHourMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            (ngModelChange)="refreshCostData()"
                        ></wj-combo-box>
                    </div>

                    <div class="input-header-group">
                        <span class="input-header">Projection Start Month</span>
                        <wj-input-date
                            [(ngModel)]="projectionStartMonth"
                            name="costProjectionStartMonth"
                            (ngModelChange)="refreshCostData()"
                            [selectionMode]="'Month'"
                            [format]="'MMM yyyy'"
                        ></wj-input-date>
                    </div>

                    <button id="btnCancel" type="button" class="btn btn-sm btn-secondary" (click)="showDataLabels = !showDataLabels">
                        {{ showDataLabels ? 'Hide Labels' : 'Show Labels' }}
                    </button>
                    <span style="line-height: 30px; color: firebrick">{{ OpenMonthText }}</span>
                    @if (projectionStartMonthWarning) {
                        <span style="line-height: 30px; color: darkorange; margin-left: 10px;">
                            {{ projectionStartMonthWarning }}
                        </span>
                    }
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-chart
                    [itemsSource]="costChartData"
                    [bindingX]="'month'"
                    [chartType]="'Line'"
                    appAutoSize
                    [header]="'Costs'"
                    [legendToggle]="true"
                >
                    <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                    <wj-flex-chart-axis
                        [wjProperty]="'axisY'"
                        [title]="isCost ? 'Cost' : 'Hours'"
                        [min]="0"
                        [format]="isCost ? 'C0' : 'N0'"
                    ></wj-flex-chart-axis>
                    <wj-flex-chart-axis wjProperty="axisX" format="MMM yy"></wj-flex-chart-axis>
                    <wj-flex-chart-data-label content="{value}" [position]="showDataLabels ? 'Top' : 'None'"></wj-flex-chart-data-label>
                    <wj-flex-chart-annotation-layer control="al">
                        <wj-flex-chart-annotation-line
                            [position]="'Center'"
                            [attachment]="'DataCoordinate'"
                            [start]="{ x: openMonth, y: -200000000 }"
                            [tooltip]="OpenMonthText"
                            [end]="{ x: openMonth, y: 20000000 }"
                            [style]="{ stroke: 'green', 'stroke-width': 3, 'stroke-opacity': 0.3 }"
                        >
                        </wj-flex-chart-annotation-line>
                    </wj-flex-chart-annotation-layer>

                    <wj-flex-chart-series [binding]="'actualLabor'" [name]="'Labor (Actual)'"></wj-flex-chart-series>
                    <wj-flex-chart-series [binding]="'projectedLabor'" [name]="'Labor (Projected)'"></wj-flex-chart-series>

                    <wj-flex-chart-series
                        [binding]="'actualFsLabor'"
                        [name]="'FS Labor (Actual)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>
                    <wj-flex-chart-series
                        [binding]="'projectedFsLabor'"
                        [name]="'FS Labor (Projected)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>

                    <wj-flex-chart-series
                        [binding]="'actualNonFsLabor'"
                        [name]="'Non-FS Labor (Actual)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>
                    <wj-flex-chart-series
                        [binding]="'projectedNonFsLabor'"
                        [name]="'Non-FS Labor (Projected)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>

                    <wj-flex-chart-series
                        [binding]="'actualMaterial'"
                        [name]="'Material (Actual)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>
                    <wj-flex-chart-series
                        [binding]="'projectedMaterial'"
                        [name]="'Material (Projected)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>

                    <wj-flex-chart-series
                        [binding]="'actualEquipment'"
                        [name]="'Equipment (Actual)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>
                    <wj-flex-chart-series
                        [binding]="'projectedEquipment'"
                        [name]="'Equipment (Projected)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>

                    <wj-flex-chart-series
                        [binding]="'actualRentals'"
                        [name]="'Rentals (Actual)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>
                    <wj-flex-chart-series
                        [binding]="'projectedRentals'"
                        [name]="'Rentals (Projected)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>

                    <wj-flex-chart-series
                        [binding]="'actualSubcontractor'"
                        [name]="'Subcontractor (Actual)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>
                    <wj-flex-chart-series
                        [binding]="'projectedSubcontractor'"
                        [name]="'Subcontractor (Projected)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>

                    <wj-flex-chart-series
                        [binding]="'actualOther'"
                        [name]="'Other (Actual)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>
                    <wj-flex-chart-series
                        [binding]="'projectedOther'"
                        [name]="'Other (Projected)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>

                    <wj-flex-chart-series
                        [binding]="'actualOverhead'"
                        [name]="'Overhead (Actual)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>
                    <wj-flex-chart-series
                        [binding]="'projectedOverhead'"
                        [name]="'Overhead (Projected)'"
                        [visibility]="'Legend'"
                    ></wj-flex-chart-series>

                    <wj-flex-chart-series [binding]="'contingency'" [name]="'Contingency'" [visibility]="'Legend'"></wj-flex-chart-series>
                </wj-flex-chart>
            </div>
        </div>
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <h4 style="color: rgb(105, 120, 130)">{{ isCost ? 'Cost' : 'Hour' }} Details</h4>
                    <grid-export [grid]="gridCostTypeCosts" [name]="'Costs'"></grid-export>
                </form>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridCostTypeCosts"
                        #gridCostTypeCosts
                        style="height: 620px"
                        (initialized)="costTypeCostsGrid.initialize(gridCostTypeCosts)"
                        [itemsSource]="costTypeCostsGrid.view"
                        [keyActionTab]="'CycleEditable'"
                        [frozenColumns]="1"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column
                            [header]="'Cost Type'"
                            [binding]="'costType'"
                            [width]="225"
                            [isReadOnly]="true"
                        ></wj-flex-grid-column>
                        @for (month of costTypeCostMonthCols; track month) {
                            <wj-flex-grid-column
                                [binding]="'detailsByMonth.' + month"
                                [format]="isCost ? 'C0' : 'N0'"
                                [align]="'right'"
                                [header]="month"
                                [aggregate]="'Sum'"
                                [width]="120"
                            >
                            </wj-flex-grid-column>
                        }
                    </wj-flex-grid>
                    <grid-selection-calculation
                        style="padding-bottom: 15px; display: block"
                        [grid]="gridCostTypeCosts"
                    ></grid-selection-calculation>
                </div>
            </div>
        </div>
        <div class="row action-toolbar" [hidden]="!isCost">
            <div class="col-12">
                <form class="form-inline">
                    <h4 style="color: rgb(105, 120, 130)">Cost Validation</h4>
                    <grid-export [grid]="gridCostTypeCostsValidation" [name]="'Cost Validation'"></grid-export>
                </form>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridCostTypeCostsValidation"
                        #gridCostTypeCostsValidation
                        style="height: 620px"
                        (initialized)="costTypeCostsGridValidation.initialize(gridCostTypeCostsValidation)"
                        [itemsSource]="costTypeCostsGridValidation.view"
                        [keyActionTab]="'CycleEditable'"
                        [frozenColumns]="1"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="225" [isReadOnly]="true"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Total Revenue'"
                            [binding]="'totalRevenue'"
                            [width]="225"
                            [isReadOnly]="true"
                            [format]="'C0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Total GP'"
                            [binding]="'totalGP'"
                            [width]="225"
                            [isReadOnly]="true"
                            [format]="'C0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Total Cost'"
                            [binding]="'totalCost'"
                            [width]="225"
                            [isReadOnly]="true"
                            [format]="'C0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Delta'"
                            [binding]="'delta'"
                            [width]="225"
                            [isReadOnly]="true"
                            [format]="'C0'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation
                        style="padding-bottom: 15px; display: block"
                        [grid]="gridCostTypeCostsValidation"
                    ></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
    <div style="margin-top: 10px" [hidden]="active !== 8">
        @if (!phaseLoadComplete) {
            <div>
                <fa-icon class="d-none d-sm-inline-block fa-spin" [icon]="faSpinner"></fa-icon> Loading Labor Phase Activity Options...
            </div>
        }
        @if (phaseLoadComplete) {
            <div>
                <div class="row action-toolbar">
                    <div class="col-12">
                        <form class="form-inline">
                            <!--<wj-combo-box [(ngModel)]="selectedJob" name="selectedJob" (ngModelChange)="refreshPhaseData()" style="width:350px"
                              [itemsSource]="activeJobsMap" [displayMemberPath]="'display'" [selectedValuePath]="'value'"></wj-combo-box>-->
                            <wj-multi-select
                                style="width: 350px"
                                [itemsSource]="activeJobsMap2"
                                [placeholder]="'Choose Jobs'"
                                [selectedValuePath]="'value'"
                                [displayMemberPath]="'display'"
                                [checkedMemberPath]="'selected'"
                                [showSelectAllCheckbox]="true"
                                [showFilterInput]="true"
                                [maxHeaderItems]="1"
                                (checkedItemsChanged)="refreshPhaseData()"
                            ></wj-multi-select>

                            <wj-multi-select
                                style="width: 350px"
                                [itemsSource]="availablePhases"
                                [placeholder]="'Choose Labor Phase Activities'"
                                [selectedValuePath]="'value'"
                                [displayMemberPath]="'display'"
                                [checkedMemberPath]="'selected'"
                                [showSelectAllCheckbox]="true"
                                [showFilterInput]="true"
                                [maxHeaderItems]="1"
                                (checkedItemsChanged)="refreshPhaseData()"
                            ></wj-multi-select>
                            <wj-combo-box
                                [(ngModel)]="isHours"
                                name="isHours"
                                style="width: 150px"
                                [itemsSource]="hourCostMap"
                                [displayMemberPath]="'display'"
                                [selectedValuePath]="'value'"
                            ></wj-combo-box>
                            <button
                                id="btnCancel"
                                type="button"
                                class="btn btn-sm btn-secondary"
                                (click)="showDataLabels = !showDataLabels"
                            >
                                {{ showDataLabels ? 'Hide Labels' : 'Show Labels' }}
                            </button>
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <wj-flex-chart
                            [bindingX]="'month'"
                            [chartType]="'Line'"
                            appAutoSize
                            [header]="isHours ? 'Hours' : 'Costs'"
                            [legendToggle]="true"
                        >
                            <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                            <wj-flex-chart-axis
                                [wjProperty]="'axisY'"
                                [title]="isHours ? 'Hours' : 'Costs'"
                                [format]="isHours ? 'N2' : 'C0'"
                            ></wj-flex-chart-axis>
                            <wj-flex-chart-data-label
                                content="{value}"
                                [position]="showDataLabels ? 'Top' : 'None'"
                            ></wj-flex-chart-data-label>
                            <wj-flex-chart-annotation-layer control="al">
                                <wj-flex-chart-annotation-line
                                    [position]="'Center'"
                                    [attachment]="'DataCoordinate'"
                                    [start]="{ x: openMonth, y: -200000000 }"
                                    [tooltip]="OpenMonthText"
                                    [end]="{ x: openMonth, y: 20000000 }"
                                    [style]="{ stroke: 'green', 'stroke-width': 3, 'stroke-opacity': 0.3 }"
                                >
                                </wj-flex-chart-annotation-line>
                            </wj-flex-chart-annotation-layer>
                            @for (phase of groupedPhaseData | keyvalue; track phase.key) {
                                <wj-flex-chart-series
                                    [itemsSource]="groupedPhaseData[phase.key + '']"
                                    [bindingX]="'month'"
                                    [binding]="isHours ? 'phaseHours' : 'phaseCost'"
                                    [name]="phase.key + ''"
                                ></wj-flex-chart-series>
                            }
                        </wj-flex-chart>
                        <!--<div *ngFor="let phase of groupedPhaseData | keyvalue">
                        {{phase.key}}
                    </div>-->
                    </div>
                </div>
                <!--<div class="row">
                <div class="col-12">
                    <wj-flex-grid id="gridCostTypeCosts" #gridCostTypeCosts style="height:620px"
                                  (initialized)="costTypeCostsGrid.initialize(gridCostTypeCosts)"
                                  [itemsSource]="costTypeCostsGrid.view"
                                  [keyActionTab]="'CycleEditable'"
                                  [frozenColumns]="1">
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Cost Type'" [binding]="'costType'" [width]="225" [isReadOnly]="true"></wj-flex-grid-column>
                        @for (month of costTypeCostMonthCols; track month) {
                            <wj-flex-grid-column [binding]="'detailsByMonth.' + month" [format]="'C0'" [align]="'right'" [header]="month" [aggregate]="'Sum'" [width]="120">
                            </wj-flex-grid-column>
                        }
                    </wj-flex-grid>
                    <grid-selection-calculation style="padding-bottom:15px;display: block" [grid]="gridCostTypeCosts"></grid-selection-calculation>
                </div>
            </div>-->
            </div>
        }
    </div>
    <div style="margin-top: 10px" [hidden]="active !== 9">
        <ul ngbNav #navInner="ngbNav" [(activeId)]="activeInner" class="nav-tabs" (activeIdChange)="tabChanged()">
            <li [ngbNavItem]="1" [destroyOnHide]="false">
                <a ngbNavLink>Jobs With No Projected Revenue</a>
                <ng-template ngbNavContent>
                    <wj-flex-grid
                        id="gridNoRev"
                        #gridNoRev
                        appAutoSize
                        [padding]="73"
                        (initialized)="noRevGrid.initialize(gridNoRev)"
                        [itemsSource]="noRevGrid.view"
                        [keyActionTab]="'CycleEditable'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Remaining Cost (From JCCP)'"
                            [binding]="'remainingCost'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Revenue ToGo (From WIPHistory)'"
                            [binding]="'revenueToGo'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridNoRev"></grid-selection-calculation>
                </ng-template>
            </li>
            <li [ngbNavItem]="2" [destroyOnHide]="false">
                <a ngbNavLink>Active Job Work Off Records</a>
                <ng-template ngbNavContent>
                    <div class="row action-toolbar">
                        <div class="col-12">
                            <form class="form-inline">
                                <action-toolbar-count [grid]="workoffsGrid"></action-toolbar-count>
                                <grid-export [grid]="gridWorkoffs" [name]="'Work Off Data'"></grid-export>
                            </form>
                        </div>
                    </div>
                    <wj-flex-grid
                        id="gridWorkoffs"
                        #gridWorkoffs
                        appAutoSize
                        [padding]="73"
                        (initialized)="workoffsGrid.initialize(gridWorkoffs)"
                        [itemsSource]="workoffsGrid.view"
                        [keyActionTab]="'CycleEditable'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'jobNum'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Period Type'" [binding]="'periodType'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Workoff Month'"
                            [binding]="'workoffMonth'"
                            [width]="'*'"
                            [format]="'d'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Actual Revenue'"
                            [binding]="'actualRevenue'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Remaining Revenue'"
                            [binding]="'remainingRevenue'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Projected Revenue'"
                            [binding]="'projectedRevenue'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Projected GM'"
                            [binding]="'projectedGp'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridWorkoffs"></grid-selection-calculation>
                </ng-template>
            </li>
            <li [ngbNavItem]="3" [destroyOnHide]="false">
                <a ngbNavLink>Active Job Phase Cost Data</a>
                <ng-template ngbNavContent>
                    <div class="row action-toolbar">
                        <div class="col-12">
                            <form class="form-inline">
                                <action-toolbar-count [grid]="validationCostsGrid"></action-toolbar-count>
                                <grid-export [grid]="gridValidationCosts" [name]="'Phase Cost Data'"></grid-export>
                            </form>
                        </div>
                    </div>
                    <wj-flex-grid
                        id="gridValidationCosts"
                        #gridValidationCosts
                        appAutoSize
                        [padding]="73"
                        (initialized)="validationCostsGrid.initialize(gridValidationCosts)"
                        [itemsSource]="validationCostsGrid.view"
                        [keyActionTab]="'CycleEditable'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Phase'" [binding]="'phase'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Cost Type'" [binding]="'costType'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Month'" [binding]="'mth'" [width]="'*'" [format]="'d'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Actual Cost'"
                            [binding]="'actualCost'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Proj Cost'"
                            [binding]="'projCost'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridValidationCosts"></grid-selection-calculation>
                </ng-template>
            </li>
            <li [ngbNavItem]="4" [destroyOnHide]="false">
                <a ngbNavLink>Earned Revenue Reconciliation</a>
                <ng-template ngbNavContent>
                    <div class="row action-toolbar">
                        <div class="col-12">
                            <form class="form-inline">
                                <action-toolbar-count [grid]="earnedVarianceGrid"></action-toolbar-count>
                                <grid-export
                                    [grid]="gridEarnedVariance"
                                    [name]="'Earned Revenue Reconciliation'"
                                ></grid-export>
                            </form>
                        </div>
                    </div>
                    <p style="margin: 10px 0">
                        Jobs where Vista's monthly earned revenue does not add up to the movement in its running total.
                        These jobs report the wrong year-to-date amount and need their WIP history rebuilt in Vista.
                        This covers every job in the company, so it is not affected by the Job Status filter or the
                        job selection on the Costs/Hours tab. An empty grid means everything reconciles.
                    </p>
                    <wj-flex-grid
                        id="gridEarnedVariance"
                        #gridEarnedVariance
                        appAutoSize
                        [padding]="73"
                        (initialized)="earnedVarianceGrid.initialize(gridEarnedVariance)"
                        [itemsSource]="earnedVarianceGrid.view"
                        [keyActionTab]="'CycleEditable'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job Name'" [binding]="'jobName'" [width]="'2*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Year'" [binding]="'year'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Sum Of Months (Shown)'"
                            [binding]="'sumOfMonths'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Earned To Date Movement'"
                            [binding]="'earnedToDateMovement'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Variance'"
                            [binding]="'variance'"
                            [width]="'*'"
                            [format]="'c0'"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Largest Variance Month'"
                            [binding]="'worstMonth'"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridEarnedVariance"></grid-selection-calculation>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="navInner" class="mt-2"></div>
    </div>

    <div style="margin-top: 10px" [hidden]="active !== 10">
        <app-cost-changes [activeJobsMap]="activeJobsMap" [active]="active"></app-cost-changes>
    </div>

    <div style="margin-top: 10px" [hidden]="active !== 11">
        <app-job-type-summary [active]="active"></app-job-type-summary>
    </div>
</div>
<style>
    .wj-gauge {
        margin: 2em auto;
        padding: 5% 12%;
    }

    .wj-gauge .wj-needle {
        fill: orangered;
        stroke: orangered;
    }

    .wj-gauge .wj-needle .wj-inner-needle-cap {
        fill: white;
    }
</style>
